// Vertical-slice deck (10 cards). The full 14-card "Moving Fortress" deck lands in Phase 12.

import type { CardDef } from './types';

export const CARDS: CardDef[] = [
  {
    id: 'card-ic-vanguard',
    name: 'Vanguard Swordsmen',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-vanguard',
    cost: { power: 110, essence: 0, command: 3 },
    ascension: 1,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 32 },
    hotkey: '1',
    ui: {
      icon: '⚔',
      roleLine: 'Flexible opening squad',
      rulesText:
        'Six small infantry. Lock Shields vs ranged focus; Finish the Line vs weakened squads.',
    },
  },
  {
    id: 'card-ic-barracks',
    name: 'Bastion Barracks',
    faction: 'iron-covenant',
    category: 'building',
    subjectId: 'b-ic-barracks',
    cost: { power: 180, essence: 0 },
    ascension: 1,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 70 },
    maxActive: 2,
    hotkey: '2',
    ui: {
      icon: '🏰',
      roleLine: 'Frontline production',
      rulesText:
        'Trains Shield Legion (Asc I) and Pike Wardens (Asc II). Ordered Muster rewards protected staging; Veteran Commandery selects an auto-production doctrine.',
    },
  },
  {
    id: 'card-ic-mobile-ballista',
    name: 'Mobile Ballista',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-mobile-ballista',
    cost: { power: 210, essence: 35, command: 6 },
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'limited', maxUses: 3, cooldown: 45 },
    hotkey: '3',
    ui: {
      icon: '🎯',
      roleLine: 'Anti-building, anti-Giant siege',
      rulesText: 'Long-range bolt thrower. Prioritizes Giants, siege, and buildings. 3 uses.',
    },
  },
  {
    id: 'card-ic-masonry',
    name: 'Emergency Masonry',
    faction: 'iron-covenant',
    category: 'spell',
    subjectId: 'sp-ic-emergency-masonry',
    cost: { power: 90, essence: 0 },
    ascension: 1,
    summonLocations: ['anywhere-friendly'],
    useModel: { kind: 'reusable', cooldown: 55 },
    hotkey: '4',
    ui: {
      icon: '🛠',
      roleLine: 'Structure stabilizer',
      rulesText: 'Target friendly building: restores 450 health over 6 s and grants 300 temporary health for 15 s.',
    },
  },
  {
    id: 'card-ic-hold-the-line',
    name: 'Hold the Line',
    faction: 'iron-covenant',
    category: 'spell',
    subjectId: 'sp-ic-hold-the-line',
    cost: { power: 140, essence: 20 },
    ascension: 2,
    summonLocations: ['anywhere-friendly'],
    useModel: { kind: 'limited', maxUses: 3, cooldown: 70 },
    hotkey: '5',
    ui: {
      icon: '🚩',
      roleLine: 'Defensive formation zone',
      rulesText:
        'For 12 s in the area: allied infantry take 30% less damage, ranged units gain 15% attack speed. Giants unaffected.',
    },
  },
  {
    id: 'card-ic-minefield',
    name: 'Aegis Minefield',
    faction: 'iron-covenant',
    category: 'trap',
    subjectId: 'tr-ic-aegis-minefield',
    cost: { power: 120, essence: 0 },
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 65 },
    maxActive: 2,
    hotkey: '6',
    ui: {
      icon: '💣',
      roleLine: 'Anti-charge trap',
      rulesText:
        'Workers place 3 visible mines. Trigger on Medium+ enemies: damage and slow; Giants are marked. Small units do not trigger them.',
    },
  },
  {
    id: 'card-ic-arcturus',
    name: 'Siege Captain Arcturus',
    faction: 'iron-covenant',
    category: 'boss',
    subjectId: 'boss-ic-arcturus',
    cost: { power: 260, essence: 40, command: 7 },
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'once' },
    hotkey: '7',
    ui: {
      icon: '👑',
      roleLine: 'Early pressure boss',
      rulesText:
        "Once per match. 160% structure damage ram; Captain's Guard at half health; +5% attack speed per escorting infantry squad (max 20%).",
    },
  },
  {
    id: 'card-ic-snipers',
    name: 'Longshot Snipers',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-longshot-snipers',
    cost: { power: 155, essence: 25, command: 4 },
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 42 },
    hotkey: '8',
    ui: {
      icon: '🏹',
      roleLine: 'Extreme-range marksmen',
      rulesText: 'Four precision riflemen. Pick off workers, supports, and exposed specialists from 14 m.',
    },
  },
  {
    id: 'card-ic-ironclad',
    name: 'Ironclad Assault Tank',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-ironclad-tank',
    cost: { power: 260, essence: 70, command: 8 },
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 85 },
    maxActive: 2,
    hotkey: '9',
    ui: {
      icon: '⚙',
      roleLine: 'Armored breakthrough',
      rulesText:
        'Squat magical tank with an impact cannon. Heavy armor, 140% structure damage, prioritizes defenses and traps.',
    },
  },
  {
    id: 'card-ic-judgment',
    name: 'Judgment Barrage',
    faction: 'iron-covenant',
    category: 'spell',
    subjectId: 'sp-ic-judgment-barrage',
    cost: { power: 260, essence: 180 },
    ascension: 4,
    summonLocations: ['anywhere-friendly'],
    useModel: { kind: 'once' },
    hotkey: '0',
    ui: {
      icon: '☄',
      roleLine: 'Ultimate bombardment',
      rulesText:
        'Once per match. After a 4 s warning, six fortress-scale impacts strike the area: heavy damage to buildings and Large targets, moderate to squads. Cores take reduced damage.',
    },
  },
];

CARDS.push(
  {
    id: 'card-ic-foundry',
    name: 'Longshot Foundry',
    faction: 'iron-covenant',
    category: 'building',
    subjectId: 'b-ic-longshot-foundry',
    cost: { power: 260, essence: 25 },
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'limited', maxUses: 2, cooldown: 60 },
    hotkey: '',
    ui: {
      icon: '🏭',
      roleLine: 'Precision & heavy production',
      rulesText:
        'Trains only Longshot Snipers. Calibration Cycle marks valuable targets for allied precision and siege fire. 2 deployments.',
    },
  },
  {
    id: 'card-ic-builder-guild',
    name: 'Royal Builder Guild',
    faction: 'iron-covenant',
    category: 'building',
    subjectId: 'b-ic-builder-guild',
    cost: { power: 170, essence: 0 },
    ascension: 1,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 60 },
    maxActive: 2,
    hotkey: '',
    ui: {
      icon: '🏗',
      roleLine: 'Construction & economy hub',
      rulesText:
        'Nearby workers construct 20% faster; acts as a Power drop-off. Trains Master Builders (Asc II, max 4).',
    },
  },
  {
    id: 'card-ic-siege-depot',
    name: 'Siege Depot',
    faction: 'iron-covenant',
    category: 'building',
    subjectId: 'b-ic-siege-depot',
    cost: { power: 320, essence: 80 },
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'limited', maxUses: 2, cooldown: 80 },
    maxActive: 1,
    hotkey: '',
    ui: {
      icon: '🛠',
      roleLine: 'Heavy recovery & boss support',
      rulesText:
        'Trains only Mobile Ballistae. Nearby deployed siege recovers faster; Ammunition Crane empowers siege attacks.',
    },
  },
  {
    id: 'card-ic-oathbound-gate',
    name: 'Oathbound Gate',
    faction: 'iron-covenant',
    category: 'building',
    subjectId: 'b-ic-oathbound-gate',
    cost: { power: 190, essence: 35 },
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'limited', maxUses: 2, cooldown: 50 },
    maxActive: 2,
    hotkey: '',
    ui: {
      icon: '🚪',
      roleLine: 'Lane-denial barrier',
      rulesText:
        'Marks the first 3 enemy squads that force passage (Covenant deals +20% to marked). Collapses forward with a stun when destroyed.',
    },
  },
  {
    id: 'card-ic-march',
    name: 'March of the Last Wall',
    faction: 'iron-covenant',
    category: 'ritual',
    subjectId: 'rit-ic-march-of-the-last-wall',
    cost: { power: 240, essence: 110 },
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'once' },
    hotkey: '',
    ui: {
      icon: '🛡',
      roleLine: 'Decisive escort ritual',
      rulesText:
        'Channel 12 s through a destructible standard. On completion: your army gains spectral shield plates and marching speed for 35 s.',
    },
  },
  {
    id: 'card-ic-iron-saint',
    name: 'The Iron Saint',
    faction: 'iron-covenant',
    category: 'boss',
    subjectId: 'boss-ic-iron-saint',
    cost: { power: 390, essence: 125, command: 12 },
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'once' },
    hotkey: '',
    ui: {
      icon: '⛪',
      roleLine: 'Commander boss',
      rulesText:
        'Once per match. Procession of Arms: gains one bonus per escort class present. Saint’s Rebuke scatters surrounding infantry.',
    },
  },
  {
    id: 'card-ic-colossus',
    name: 'Crown Colossus',
    faction: 'iron-covenant',
    category: 'boss',
    subjectId: 'boss-ic-crown-colossus',
    cost: { power: 620, essence: 260, command: 20 },
    ascension: 4,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'once' },
    hotkey: '',
    ui: {
      icon: '🏰',
      roleLine: 'Ascension IV finisher',
      rulesText:
        'Once per match. 12 s announced assembly. Kingbreaker Hammer crushes structures and halves repairs; mounts 2 squads (Snipers / Shield Legion).',
    },
  },
);

// v0.2.4 roster completion — the remaining Iron Covenant unit cards (bible IC-03..IC-17).
CARDS.push(
  {
    id: 'card-ic-crossbow-retinue',
    name: 'Crossbow Retinue',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-crossbow-retinue',
    cost: { power: 105, essence: 0, command: 3 }, // bible IC-03
    ascension: 1,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 34 }, // bible IC-03
    hotkey: '',
    ui: {
      icon: '🏹',
      roleLine: 'Reliable ranged damage',
      rulesText:
        'Five crossbowmen. Pavise Stakes shrug off incoming volleys; Focused Bolts punish a worn-down target.',
    },
  },
  {
    id: 'card-ic-royal-scouts',
    name: 'Royal Scouts',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-royal-scouts',
    cost: { power: 90, essence: 0, command: 2 }, // bible IC-04
    ascension: 1,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 30 }, // bible IC-04
    hotkey: '',
    ui: {
      icon: '🐎',
      roleLine: 'Fast capture & harassment',
      rulesText:
        'Four light horsemen — the fastest squad in the Covenant. Volley workers and supports on the move; avoid straight fights.',
    },
  },
  {
    id: 'card-ic-forge-clerics',
    name: 'Forge Clerics',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-forge-clerics',
    cost: { power: 145, essence: 30, command: 3 }, // bible IC-08
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 52 }, // bible IC-08
    hotkey: '',
    ui: {
      icon: '⚒',
      roleLine: 'Repair & armor support',
      rulesText:
        'Three armored clerics. Tempered Blessing hardens nearby armor; Field Mend restores the weakest ally. Max three active.',
    },
  },
  {
    id: 'card-ic-iron-cavalry',
    name: 'Iron Cavalry',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-iron-cavalry',
    cost: { power: 175, essence: 20, command: 5 }, // bible IC-09
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 60 }, // bible IC-09
    hotkey: '',
    ui: {
      icon: '🐴',
      roleLine: 'Shock charge & pursuit',
      rulesText:
        'Five plated riders. Breakthrough Charge scatters exposed lines; Wheel and Reform disengages for another pass.',
    },
  },
  {
    id: 'card-ic-oathbreaker-hunters',
    name: 'Oathbreaker Hunters',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-oathbreaker-hunters',
    cost: { power: 190, essence: 55, command: 4 }, // bible IC-12
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 66 }, // bible IC-12
    hotkey: '',
    ui: {
      icon: '⛓',
      roleLine: 'Anti-support executioners',
      rulesText:
        'Four masked hunters. Writ of Condemnation cuts the target’s healing; Execution Chains root and punish isolated prey.',
    },
  },
  {
    id: 'card-ic-royal-artificers',
    name: 'Royal Artificers',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-royal-artificers',
    cost: { power: 180, essence: 60, command: 4 }, // bible IC-13
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 70 }, // bible IC-13
    hotkey: '',
    ui: {
      icon: '🔧',
      roleLine: 'Machine enhancement',
      rulesText:
        'Three master engineers. Aegis Drone screens allies from projectiles; Overcharge Engine spurs nearby machines. Max two active.',
    },
  },
  {
    id: 'card-ic-bastion-golems',
    name: 'Bastion Golems',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-bastion-golems',
    cost: { power: 230, essence: 60, command: 6 }, // bible IC-14
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 78 }, // bible IC-14
    hotkey: '',
    ui: {
      icon: '🗿',
      roleLine: 'Immovable frontline',
      rulesText:
        'Two stone-and-iron guardians. Stonewall Stance braces under fire; Retaliation Bell staggers swarming attackers.',
    },
  },
  {
    id: 'card-ic-gryphon-lancers',
    name: 'Gryphon Lancers',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-gryphon-lancers',
    cost: { power: 245, essence: 80, command: 6 }, // bible IC-15
    ascension: 3,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'limited', maxUses: 2, cooldown: 90 }, // bible IC-15
    hotkey: '',
    ui: {
      icon: '🦅',
      roleLine: 'Dive strikes & extraction',
      rulesText:
        'Three gryphon riders — the Covenant’s fastest heavy squad. Skyhook Dive pins a backline target; Rescue Lift saves a failing ally. 2 uses.',
    },
  },
  {
    id: 'card-ic-fortress-ram',
    name: 'Fortress Ram',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-fortress-ram',
    cost: { power: 310, essence: 110, command: 9 }, // bible IC-16
    ascension: 4,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'limited', maxUses: 2, cooldown: 105 }, // bible IC-16
    hotkey: '',
    ui: {
      icon: '🐏',
      roleLine: 'Covered Core breaker',
      rulesText:
        'Roofed Giant siege construct. Covered Advance shelters escorting infantry; Gatebreaker lands crushing blows on structures. 2 uses.',
    },
  },
  {
    id: 'card-ic-kings-exemplars',
    name: "King's Exemplars",
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-kings-exemplars',
    cost: { power: 300, essence: 130, command: 7 }, // bible IC-17
    ascension: 4,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'limited', maxUses: 2, cooldown: 100 }, // bible IC-17
    hotkey: '',
    ui: {
      icon: '⚜',
      roleLine: 'Late-game duelists',
      rulesText:
        'Five legendary champions. Royal Challenge singles out the strongest enemy; the last survivor plants the banner and fights on. 2 uses.',
    },
  },
);

CARDS.push(
  {
    id: 'card-ic-banner-captain',
    name: 'Banner Captain',
    faction: 'iron-covenant',
    category: 'unit',
    subjectId: 'u-ic-banner-captain',
    cost: { power: 150, essence: 20, command: 4 }, // TEST
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 58 }, // TEST
    hotkey: '',
    ui: {
      icon: '🚩',
      roleLine: 'Formation support',
      rulesText: 'A disciplined officer whose standard steadies nearby infantry.',
    },
  },
  {
    id: 'card-ic-bulwark-arbalest',
    name: 'Bulwark Arbalest',
    faction: 'iron-covenant',
    category: 'building',
    subjectId: 'b-ic-bulwark-arbalest',
    cost: { power: 220, essence: 30 }, // TEST
    ascension: 2,
    summonLocations: ['core', 'controlled-site'],
    useModel: { kind: 'reusable', cooldown: 65 }, // TEST
    maxActive: 3,
    hotkey: '',
    ui: {
      icon: '🏹',
      roleLine: 'Dedicated anti-heavy tower',
      rulesText: 'Slow armor-piercing bolts prioritize Large, Giant, and siege targets. Brace Shot rewards protected placement.',
    },
  },
);

// The default deck lives in content/factions.ts (FactionDef.defaultDeck).
